import { useState } from 'react'

import FormsyInput from '@components/Textfield/withFormsy'
import { withTranslate } from '@i18n/utils'

import { DOCUMENT_TYPE_NUMBER_LENGTH_VALIDATION, DOCUMENT_TYPE_NUMBER_VALIDATION, DOCUMENT_TYPES } from './constants'
import { fillDocumentNumberMask, stripDocumentNumber } from './utils'
import Select from '@components/Select/RequiredSelectWithFormsy'

const DocumentDataFields = ({
    documentType,
    documentNumber,
    hideType,
    fieldClassName = '',
    translate: t,
    isPurchaseFlow,
    onChange,
}) => {
    const [documentTypeValue, setDocumentType] = useState(documentType)
    const [documentNumberValue, setDocumentNumber] = useState(() =>
        fillDocumentNumberMask(documentType, documentNumber)
    )
    const tLabel = key => t(`document.data.${key}`)
    const documentTypeValidation = DOCUMENT_TYPE_NUMBER_VALIDATION[documentTypeValue]
    const documentTypeNumberLength = DOCUMENT_TYPE_NUMBER_LENGTH_VALIDATION[documentTypeValue]

    return (
        <div className={!isPurchaseFlow && !hideType ? 'row' : fieldClassName}>
            {!isPurchaseFlow && !hideType && (
                <div className={`${fieldClassName} mb-3`}>
                    <Select
                        options={DOCUMENT_TYPES}
                        getSelectValue={() => DOCUMENT_TYPES.find(({ value }) => value === documentTypeValue)}
                        name="documentType"
                        placeholder={tLabel('type')}
                        value={documentTypeValue}
                        onChange={newValue => {
                            setDocumentType(newValue)
                            setDocumentNumber('')
                            onChange && onChange({ target: { name: 'documentType', value: newValue } })
                        }}
                        required
                    />
                </div>
            )}
            <div className={isPurchaseFlow ? '' : fieldClassName}>
                <FormsyInput
                    value={documentNumberValue}
                    onChange={event => {
                        setDocumentNumber(event.currentTarget.value)
                        onChange && onChange(event)
                    }}
                    name="documentNumber"
                    label={tLabel('documentNumber')}
                    required
                    onFocus={() => setDocumentNumber(stripDocumentNumber(documentNumberValue))}
                    onBlur={() =>
                        setDocumentNumber(
                            fillDocumentNumberMask(documentTypeValue, documentNumberValue, documentNumberValue)
                        )
                    }
                    validationErrors={{
                        isDefaultRequiredValue: tLabel(`validation.${documentTypeValue?.toLowerCase()}.required`),
                        [documentTypeNumberLength]: documentTypeValue
                            ? tLabel(`validation.${documentTypeValue?.toLowerCase()}.required`)
                            : undefined,
                        [documentTypeValidation]: documentTypeValue
                            ? tLabel(`validation.${documentTypeValue?.toLowerCase()}.incorrect`)
                            : undefined,
                    }}
                    validations={{
                        ...(documentTypeNumberLength && { [documentTypeNumberLength]: true }),
                        ...(documentTypeValidation && { [documentTypeValidation]: true }),
                    }}
                />
            </div>
        </div>
    )
}

export default withTranslate(DocumentDataFields)
